<script lang="ts">
  import { onMount } from 'svelte';
  import { afterNavigate } from '$app/navigation';
  import { dev } from '$app/environment';
  import '../app.css';
  import Navbar from '$lib/components/Navbar.svelte';
  import Footer from '$lib/components/Footer.svelte';
  import CookieBanner from '$lib/components/CookieBanner.svelte';
  import ExitPopup from '$lib/components/ExitPopup.svelte';
  import { PUBLIC_UMAMI_WEBSITE_ID } from '$env/static/public';

  let { children } = $props();

  function loadAnalytics() {
    if (dev) return;
    const clarity = document.createElement('script');
    clarity.async = true;
    clarity.innerHTML = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","vmj1x15prg");`;
    document.head.appendChild(clarity);

    // @ts-ignore
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted',
      'ad_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted'
    });
  }

  function loadGTagBase() {
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-N6GCK9NGBJ';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);
    // @ts-ignore
    window.gtag('js', new Date());
    // @ts-ignore
    window.gtag('config', 'G-N6GCK9NGBJ', {
      'send_page_view': true,
      'anonymize_ip': true,
      'ads_data_redaction': true,
      'url_passthrough': true
    });
  }

  function loadUmami() {
    if (dev) return;
    const umami = document.createElement('script');
    umami.src = 'https://eu.umami.is/script.js';
    umami.async = true;
    umami.setAttribute('data-website-id', PUBLIC_UMAMI_WEBSITE_ID || 'a0e74a57-85cc-487c-95b3-8df2a4ecb222');
    umami.setAttribute('data-auto-track', 'true');
    umami.setAttribute('data-domains', 'bleunk.com');
    document.head.appendChild(umami);
  }

  onMount(() => {
    loadUmami();
    loadGTagBase();
    
    // Load Clarity immediately for session tracking
    loadAnalytics();

    window.addEventListener('bleunk-consent-changed', () => {
      if (localStorage.getItem('bleunk-consent') === 'all') {
        // Analytics already loaded
      }
    });
  });

  afterNavigate(() => {
    // Force scroll to top on every navigation
    window.scrollTo({ top: 0, behavior: 'instant' });
    
    // @ts-ignore
    if (typeof window.umami !== 'undefined') {
      // @ts-ignore
      window.umami.track();
    }
    // @ts-ignore
    if (typeof window.gtag !== 'undefined') {
      // @ts-ignore
      window.gtag('config', 'G-N6GCK9NGBJ', {
        page_path: window.location.pathname,
        send_page_view: true
      });
    }
  });
</script>

<a href="#main-content" class="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-xl focus:bg-[#C9A87C] focus:text-[#08080E] focus:text-sm focus:font-semibold">
  Skip to content
</a>

<div class="min-h-screen bg-void font-body text-content overflow-x-hidden">
  <!-- Decorative background -->
  <div aria-hidden="true" class="fixed inset-0 pointer-events-none overflow-hidden z-0">
    <div class="absolute inset-0 bg-line-grid"></div>
    <svg class="absolute inset-0 w-full h-full" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="lg-gold" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#C9A87C" stop-opacity="0"/><stop offset="45%" stop-color="#C9A87C" stop-opacity="0.13"/><stop offset="100%" stop-color="#C9A87C" stop-opacity="0"/></linearGradient>
        <linearGradient id="lg-steel" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#8E9BAF" stop-opacity="0"/><stop offset="50%" stop-color="#8E9BAF" stop-opacity="0.09"/><stop offset="100%" stop-color="#8E9BAF" stop-opacity="0"/></linearGradient>
        <linearGradient id="lg-sage" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#7A9E90" stop-opacity="0"/><stop offset="55%" stop-color="#7A9E90" stop-opacity="0.08"/><stop offset="100%" stop-color="#7A9E90" stop-opacity="0"/></linearGradient>
      </defs>
      <rect x="-200" y="110" width="1840" height="1.5" fill="url(#lg-gold)" transform="rotate(-10 720 450)"/>
      <rect x="-200" y="265" width="1840" height="1" fill="url(#lg-steel)" transform="rotate(-10 720 450)"/>
      <rect x="-200" y="400" width="1840" height="1.5" fill="url(#lg-gold)" transform="rotate(-10 720 450)"/>
      <rect x="-200" y="545" width="1840" height="1" fill="url(#lg-sage)" transform="rotate(-10 720 450)"/>
      <rect x="-200" y="685" width="1840" height="1.5" fill="url(#lg-steel)" transform="rotate(-10 720 450)"/>
      <rect x="-200" y="810" width="1840" height="1" fill="url(#lg-gold)" transform="rotate(-10 720 450)"/>
    </svg>
  </div>

  <Navbar />
  <main id="main-content" class="relative z-10">
    {@render children()}
  </main>
  <Footer />
  <CookieBanner />
  <ExitPopup />
</div>
